import {createContext, useContext} from 'react';
import {DEFAULT_DOCK_CONFIG, type DockConfig, type DockItemHandle} from './types';

export interface DockContextValue extends DockConfig {
  /** Items self-register so the wrapper can drive them without re-rendering. */
  register(id: string, handle: DockItemHandle): () => void;
}

export const DockContext = createContext<DockContextValue>({
  ...DEFAULT_DOCK_CONFIG,
  register: () => () => {},
});

export function useDockConfig(): DockContextValue {
  return useContext(DockContext);
}
